// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";

export const REQUEST_REDIRECTION_PARAMS = "REQUEST_REDIRECTION_PARAMS";
export const RECEIVE_REDIRECTION_PARAMS = "RECEIVE_REDIRECTION_PARAMS";
export const RECEIVE_ERROR_REDIRECTION_PARAMS =
  "RECEIVE_ERROR_REDIRECTION_PARAMS";
export const RESET_ERROR = "RESET_ERROR";
export const RESET_REDIRECTION = "RESET_REDIRECTION";
export const RESET_REDIRECTION_PARAMS = "RESET_REDIRECTION_PARAMS";

function requestRedirection() {
  return {
    type: REQUEST_REDIRECTION_PARAMS
  };
}

function receiveRedirectParams(redirectParams) {
  return {
    type: RECEIVE_REDIRECTION_PARAMS,
    redirectParams
  };
}

function receiveRedirectError(message) {
  return {
    type: RECEIVE_ERROR_REDIRECTION_PARAMS,
    message
  };
}

export function resetError() {
  return { type: RESET_ERROR };
}

export function resetRedirection(message) {
  return {
    type: RESET_REDIRECTION,
    message
  };
}

export function resetRedirectionParams() {
  return {
    type: RESET_REDIRECTION_PARAMS
  };
}

const getCsrfToken = () => {
  const token = document.cookie.match(
    "(^|[^;]+)\\s*XSRF-TOKEN\\s*=\\s*([^;]+)"
  );
  return token ? token.pop() : "";
};

export function fetchRedirectionParams(uuid, form, type) {
  return dispatch => {
    dispatch(requestRedirection());
    return window
      .fetch(`/public/v1/charge/${uuid}/submit/${type}`, {
        method: "POST",
        body: JSON.stringify(form),
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        }
      })
      .then(
        resp => {
          if (resp.status === 205) window.location.reload();
          return resp.json();
        },
        error => dispatch(receiveRedirectError(error))
      )
      .then(json => {
        if (json.code && json.message) throw new Error(json.message);
        dispatch(receiveRedirectParams(json));
      })
      .catch(e => {
        dispatch(receiveRedirectError(e.message));
      });
  };
}
